<template>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Client Details</h1>
                    <table>
                    <thead>
                        <tr>
                        <th>Client Details</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>                            
                            <td>Name</td>
                            <td>{{ client.name }}</td>
                        </tr>
                        <tr>                            
                            <td>Company Number</td>
                            <td>{{ client.companyNumber }}</td>
                        </tr>
                        <tr>                            
                            <td>Phone Number</td>
                            <td>{{ client.phoneNumber }}</td>
                        </tr>
                        <tr>                            
                            <td valign="top">Address</td>
                            <td>{{ client.address.addressLine1 }}<br/>
                                <span v-if=client.address.addressLine2>{{ client.address.addressLine2 }}<br/></span>
                                <span v-if=client.address.addressLine3>{{ client.address.addressLine3 }}<br/></span>
                                <span v-if=client.address.addressLine4>{{ client.address.addressLine4 }}<br/></span>
                                <span v-if=client.address.country>{{ client.address.country }}<br/></span>
                                <span v-if=client.address.postcode>{{ client.address.postcode }}<br/></span></td>
                        </tr>
                        <tr v-if="identity.type === 'Administrator'">                            
                            <td>Client Type</td>
                            <td>{{ splitByCapitals(client.clientType) }}</td>
                        </tr>
                        <tr v-if="identity.type === 'Administrator'">                            
                            <td>Onboarding Type</td>
                            <td>{{ splitByCapitals(client.clientOnboardingType) }}</td>
                        </tr>
                    </tbody>
                    </table>
                    <br/>
                    <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
                </div>
            </div>
        </section>

</div>


  </section>
</template>

<script setup>
import { ref } from 'vue'
import { splitByCapitals } from '@/helpers/strings'
import { useRouter } from 'vue-router'
import { useIdentityStore } from '@/stores/identity'

import { useClientStore } from '@/stores/client'

const router  = useRouter()
const loaded = ref(true);

const client = useClientStore()
const identity = useIdentityStore();


</script>

